module.exports = __webpack_public_path__ + "img/3_banner.f90cffae.png";